module.exports = __webpack_public_path__ + "static/media/logo-el-carioca-navbar-v2.906bd382.png";